import React from 'react';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import type { UserOption } from '@atlassian/jira-base-user-picker/src/types.tsx';
import SingleUserPickerField from '@atlassian/jira-issue-create-commons/src/ui/single-userpicker-field/index.tsx';
import { USER_CF_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import { AssigneeFieldPlaceholder } from '../../../ui/field-placeholders/index.tsx';
import type { FieldTypeConfig } from '../types.tsx';
import { singleUserPickerFieldWriter } from '../writers/index.tsx';

export const UserCustomFieldTypeConfig: FieldTypeConfig<UserOption> = {
	icon: PersonAvatarIcon,
	type: USER_CF_TYPE,
	Component: SingleUserPickerField,
	placeholder: <AssigneeFieldPlaceholder />,
	writer: singleUserPickerFieldWriter,
};
